import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_2wnzlaczud: FaireBrandEntity = {
  token: "b_2wnzlaczud",
  type: "brand",
  name: "JADE BY JANE",
  avatarUrl:
    "https://cdn.faire.com/fastly/94c9d1d2c720c1748a996223609414bf37cc920c071d70ea34419d504135a8a8.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/d411708b4b155596b49be50781960498f5f714025e591416ffcb43caf1e8cf4c.png",
  logoUrl:
    "https://cdn.faire.com/fastly/94c9d1d2c720c1748a996223609414bf37cc920c071d70ea34419d504135a8a8.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d411708b4b155596b49be50781960498f5f714025e591416ffcb43caf1e8cf4c.png",
  location: "LOS ANGELES, CA, USA",
  minimumOrderDollars: 0,
  rating: 4.8,
  reviewCount: 668,
  isInsider: true,
  description:
    "Jade by Jane is a manufacturer and wholesaler specializing in women's young contemporary and PLUS size clothing.\nWe have a full design, production, sample room, and sales team in the heart of the Los Angeles Fashion District.\nWe have an ongoing commitment to our customers in providing excellent customer service to all.\nAs these efforts are ongoing, if at any time you have any questions, please contact our Customer Service team for assistance.",
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:54:48.329Z",
    importedBy: "entity-db-cli",
  },
};
